"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classes = require('./AmountInput.module.css');

var ONE_ETH = 1000000000000000000;

var AmountInput = function AmountInput(_a) {
  var onChange = _a.onChange,
      asset = _a.asset,
      value = _a.value,
      disabled = _a.disabled;
  var isUSD = false;
  var usdValue;

  if (!isUSD && asset) {
    try {
      isUSD = asset.getUSDValue(ONE_ETH.toString()) === '1.00';
      usdValue = asset.getUSDValue((parseFloat(value) * ONE_ETH).toString());
    } catch (e) {}
  }

  return react_1.default.createElement("div", null, react_1.default.createElement("div", {
    className: classes.inputContainer
  }, isUSD && react_1.default.createElement("div", {
    className: classes.unit
  }, "$"), react_1.default.createElement("input", {
    type: "number",
    placeholder: "0.00",
    className: classes.input,
    onChange: onChange,
    value: value,
    disabled: disabled,
    min: "0"
  }), !isUSD && asset && react_1.default.createElement("div", {
    className: classes.unit
  }, asset.name)), usdValue && react_1.default.createElement("div", null, "$", usdValue, " USD"));
};

exports.default = AmountInput;